/* import __COLOCATED_TEMPLATE__ from './hand-off-in-salesforce.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
}

const HandOffInSalesforceComponent = templateOnlyComponent<Signature>();
export default HandOffInSalesforceComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::Markers::HandOffInSalesforce': typeof HandOffInSalesforceComponent;
  }
}
